export default "__VITE_ASSET__FBQwfEQx__"